<div class="login">
<!-- <particles [params]="myParams" [style]="myStyle" [width]="width" [height]="height"></particles> -->
<form [formGroup]="loginForm" (ngSubmit)="login()">
  <div class="login-box" [ngClass]="{ shake : loginInvalid  }">
    <div class="login-logo">
      <b>GAUSS</b>&nbsp;<b>F</b>oundation&nbsp;<b>P</b>latform
    </div>
    <div class="login-box-body mt-10">
      <div class="row">
        <div class="col">
          <p class="login-box-msg">{{ scope.message }}</p>
          <p class="login-box-msg">Sign in to start your session</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="row form-group">
            <label for="email" class="col-sm-2 control-label">Email</label>
            <div class="col-sm-10">
              <input type="email" class="form-control" id="email" formControlName="email" placeholder="E-Mail Address" autocomplete="off">
            </div>
          </div>
          <div class="row form-group">
            <label for="email" class="col-2 control-label">Password</label>
            <div class="col-10">
              <input type="password" class="form-control" id="password" formControlName="password" placeholder="password" autocomplete="off">
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-10">
        <div class="col">
          <span class="error small">{{ errorMessage ? errorMessage : '&nbsp;'}}</span>
        </div>
      </div>
      <div class="row mt-10">
        <div class="col">
          <button type="submit" class="login-btn btn btn-primary btn-block btn-flat">
            <span *ngIf="!submitted"><i class="fas fa-key"></i></span>
            <span *ngIf="submitted"><i class="fas fa-spinner fa-spin"></i></span>
            <span>Login</span>
          </button>
        </div>
      </div>
      <!-- <div class="social-auth-links text-center">
        <p>- OR -</p>
        <a href="#" class="btn btn-block btn-social btn-facebook btn-flat"><i class="fa fa-facebook"></i> Sign in using
          Facebook</a>
        <a href="#" class="btn btn-block btn-social btn-google btn-flat"><i class="fa fa-google-plus"></i> Sign in using
          Google+</a>
      </div> -->
      <!-- <a href="#">I forgot my password</a><br>
      <a href="register.html" class="text-center">Register a new membership</a> -->

    </div>
  </div>
</form>
</div>

